import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  HEALTH_PROFILE_PATH,
  ASTHMA_PROFILE_PATH,
  CANCER_PROFILE_PATH,
  DEPRESSION_PROFILE_PATH,
  DIABETES_PROFILE_PATH,
  MEDICAL_CONDITIONS_PATH,
  HEART_ATTACK_PROFILE_PATH,
  SLEEP_APNEA_PROFILE_PATH,
  STROKE_PROFILE_PATH,
  TOBACCO_PROFILE_PATH,
  HEALTH_LIFESTYLE_PATH,
  PRUDENTIAL_QUOTATION_PATH,
  CONTINUE_ONLINE_ADD_ADHD_PATH,
  CONTINUE_ONLINE_ANXIETY_PATH,
  CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH,
  CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH,
  CONTINUE_ONLINE_FAMILY_HISTORY_PATH,
  CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH,
} from '../constants';
import {
  AsthmaProfile,
  CancerProfile,
  DepressionProfile,
  DiabetesProfile,
  MedicalConditionsProfile,
  HealthLifestyle,
  PrudentialQuotation,
  HealthProfile,
  HeartAttackProfile,
  SleepApneaProfile,
  StrokeProfile,
  TobaccoProfile,
  AddAdhdDetails,
  AnxietyProfile,
  BloodPressureDetails,
  CholesterolDetails,
  FamilyHistory,
  PregnancyHistory,
} from './lazyLoadableComponents';

const HealthRoutes: React.FC = () => (
  <Routes>
    <Route path={HEALTH_PROFILE_PATH} element={<HealthProfile />} />
    <Route path={MEDICAL_CONDITIONS_PATH} element={<MedicalConditionsProfile />} />
    <Route path={HEALTH_LIFESTYLE_PATH} element={<HealthLifestyle />} />
    <Route path={PRUDENTIAL_QUOTATION_PATH} element={<PrudentialQuotation />} />
    <Route path={CONTINUE_ONLINE_FAMILY_HISTORY_PATH} element={<FamilyHistory />} />
    <Route path={ASTHMA_PROFILE_PATH} element={<AsthmaProfile />} />
    <Route path={CANCER_PROFILE_PATH} element={<CancerProfile />} />
    <Route path={DEPRESSION_PROFILE_PATH} element={<DepressionProfile />} />
    <Route path={DIABETES_PROFILE_PATH} element={<DiabetesProfile />} />
    <Route path={HEART_ATTACK_PROFILE_PATH} element={<HeartAttackProfile />} />
    <Route path={SLEEP_APNEA_PROFILE_PATH} element={<SleepApneaProfile />} />
    <Route path={STROKE_PROFILE_PATH} element={<StrokeProfile />} />
    <Route path={TOBACCO_PROFILE_PATH} element={<TobaccoProfile />} />
    <Route path={HEALTH_LIFESTYLE_PATH} element={<HealthLifestyle />} />
    <Route path={MEDICAL_CONDITIONS_PATH} element={<MedicalConditionsProfile />} />
    <Route path={CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH} element={<BloodPressureDetails />} />
    <Route path={CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH} element={<CholesterolDetails />} />
    <Route path={CONTINUE_ONLINE_ADD_ADHD_PATH} element={<AddAdhdDetails />} />
    <Route path={CONTINUE_ONLINE_ANXIETY_PATH} element={<AnxietyProfile />} />
    <Route path={CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH} element={<PregnancyHistory />} />
  </Routes>
);

export default HealthRoutes;
